import { render, staticRenderFns } from "./OrderAttention.vue?vue&type=template&id=69b8e3ae"
import script from "./OrderAttention.vue?vue&type=script&lang=js"
export * from "./OrderAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports